import webcall from '@/libs/webcall';

/**
 * Convert model into payload format
 * `null` will be returned if model is empty or is not filled
 * @param {Object} model
 */
export const getPayloadFromModel = (model, options) => {
  const { other, values } = model;

  const trimmedOther = other.trim();
  if (trimmedOther.length === 0 && values.length === 0) {
    return null;
  }

  const valueSet = values.reduce((acc, value) => {
    acc[value] = true;
    return acc;
  }, {});

  return options.reduce((acc, option) => {
    acc[`choice_${option}`] = !!valueSet[option];
    return acc;
  }, {
    choice_other: trimmedOther,
  });
};

/**
 *
 * @param {*} surveyPayload
 * @param {{
 *   userId: number;
 *   country: string;
 *   submissionId: string;
 * }} additionalData
 */
export const postSurvey = (surveyPayload, additionalData) => (
  webcall.survey.postSurvey('creator-post-submission-survey', {
    ...additionalData,
    ...surveyPayload,
  })
);



// WEBPACK FOOTER //
// ./src/components/Submission/Shared/PostSubmissionDialog/surveyModelHelper.js